<template>
	<div name="hres6ju-popup-training" id="hres6ju-popup-training" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">
	    <div class="modal-content">
	      <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">{{ labels['HRTR53C1']['140'] }}</h4>
        </div>

        <div class="modal-body detail detail-responsive">	
        	<div class="box-body">
						<div class="row">
			        <div class="col-xs-6 col-md-6 input-half-left">
			          <div class="form-group ">
			            <label>{{ labels['HRTR53C1']['10'] }} :</label>
			            <div class="input-group width-70">
	                  <hrms-dropdown-year v-model="dteyear"
	                                    :minYear="minYear"
	                                    :maxYear="maxYear"
	                                    :nowLang="nowLang" />
                  </div>

			          </div>
			        </div>
			        <div class="col-xs-6 col-md-6 input-half-right">
			          <div class="form-group ">
			            <label>{{ labels['HRTR53C1']['20'] }} :</label>
			            <div class="input-group width-70">
                    <hrms-dropdown-month v-model="dtemonth"
                                     :nowLang="nowLang" />

				          </div>
			          </div>
			        </div> 
			      </div>
			      <div class="row">
			        <div class="col-xs-6 col-md-6 input-half-left">
			          <div class="form-group ">
			            <label>{{ labels['HRTR53C1']['30'] }} :</label>
			            <div class="input-group width-70">
				          	<hrms-dropdown  v-model="codplan" 
                                  :options="arrCodplan[nowLang]" />

				          </div>
			          </div>
			        </div> 
		
			        <div class="col-xs-6 col-md-6 input-half-right">
			          <div class="form-group ">
			            <label>{{ labels['HRTR53C1']['40'] }} :</label>
			            <div class="input-group width-70">
				          	<hrms-dropdown  v-model="codcours" 
                                  :options="arrCodcours[nowLang]" />
				          </div>
			          </div>
			        </div> 
			        
			      </div>  
			      <div class="col-xs-12 col-md-12">
			          <div class="form-group-button">
			            <div class="btn button-in-search bg-color-skin" @click="receivedHres6juTraining(trainingParams())"><i class="fa fa-search"></i> {{ labelsButton['search'] }}</div>
			          </div>
			        </div>

					</div>

					<div class="detail detail-responsive">
            <div id="accordion_training">  
				      <div class="panel box-collapse border-color-skin">
				        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion_training" href="#detail_training">
				          <h3 class="box-title">
				            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRTR53C1']['140'] }}
				          </h3>
				        </div>
				        <div id="detail_training" class="panel-collapse collapse in tab-detail">
				          <div class="panel-body">

				            <hrms-table :columns="popupTrainingTable" 
																:data="training.table" />

				          </div>
				        </div>
				      </div> 
				    </div>  
					</div>	
	
        </div>
	    </div>
    </div>
	</div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'hres6ju-popup-training',
  data () {
    return {
      btn_search: 'ค้นหา',
      dteyear: moment().year(),
      dtemonth: moment().month() + 1,
      minYear: moment().year() - 20,
      maxYear: moment().year(),
      codplan: '',
      codcours: ''
    }
  },
  props: [ 'labels', 'nowLang', 'training', 'data', 'popupTrainingTable', 'arrCodplan', 'arrCodcours', 'receivedHres6juTraining', 'codempid', 'labelsButton' ],
  methods: {
    trainingParams () {
      return {
        p_codempid: this.codempid,
        p_dteyear: this.dteyear,
        p_dtemonth: this.dtemonth,
        p_codplan: this.codplan,
        p_codcours: this.codcours
      }
    }
  }
}
</script>





// WEBPACK FOOTER //
// popupTraining.vue?33a0941e